import "./App.css";
import Dashboard from "./Components/Dashboard";
import Login from "./Components/Login";
import Loader from "./Components/Loader";
import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import Secure from "./Helpers/Secure";

function App() {


  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const login = () => {
    setIsAuthenticated(true);
    const key = Secure.encrypt()
    localStorage.setItem("isAuthenticated", key);
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("isAuthenticated");
  };

  const PrivateRoute = ({ element }) => {
    return isAuthenticated ? element : <Navigate to="/" />;
  };

  const PublicRoute = ({ element }) => {
    return isAuthenticated ? <Navigate to="/dashboard" /> : element;
  };

  useEffect(() => {
    const auth = localStorage.getItem("isAuthenticated");
    if (auth) {
      const result = Secure.decrypt(auth)
      if (result === "sakshi") {
        setIsAuthenticated(true);
      }
    }

    setLoading(false);
  }, []);

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  }


  return (
    <>
      <Routes>
        <Route path="/" element={<PublicRoute element={<Login login={login} />} />} />
        <Route path="/dashboard" element={<PrivateRoute element={<Dashboard logout={logout} />} />} />
        <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/"} replace />} />
      </Routes>
    </>
  );
}

export default App;
